import script from "./formrejecttj.vue?vue&type=script&lang=ts&setup=true"
export * from "./formrejecttj.vue?vue&type=script&lang=ts&setup=true"

import "./formrejecttj.vue?vue&type=style&index=0&id=0cec44a1&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cec44a1"]])

export default __exports__